import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DatePicker from './DatePicker.json';
import Header from './Header.json';
import InvestigationalUseDialog from './InvestigationalUseDialog.json';
import MeasurementTable from './MeasurementTable.json';
import Onboarding from './Onboarding.json';
import DataRow from './DataRow.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyList from './StudyList.json';
import Tools from './Tools.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';

export default {
  es: {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DatePicker,
    Header,
    InvestigationalUseDialog,
    MeasurementTable,
    Onboarding,
    DataRow,
    SidePanel,
    StudyBrowser,
    StudyList,
    Tools,
    UserPreferencesModal,
    ViewportDownloadForm,
  },
};
